const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getLabels = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/schema/persons",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getSubscriberCount = async (searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
          `personal/persons/count?search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL + `personal/overall/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getTag = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/tags",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getTagCount = async (tag) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
      `personal/tags/persons/count/?tag=${tag}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getCompany = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/company",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getPersons = async (limit, offset, searchText , pub=false ) => {
  const response = await axios.get(
    searchText
      ? pub?  process.env.REACT_APP_API_BASE_URL +
      `leads?limit=${limit}&offset=${offset}&search=${searchText}`  : process.env.REACT_APP_API_BASE_URL +
          `personal/persons?limit=${limit}&offset=${offset}&search=${searchText}`
      :  pub?  process.env.REACT_APP_API_BASE_URL +
      `leads?limit=${limit}&offset=${offset}`  :process.env.REACT_APP_API_BASE_URL +
          `personal/persons?limit=${limit}&offset=${offset}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const filterPersonsData = async (tag,limit, offSet,) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
      `personal/tags/persons?tag=${tag}&limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const limitPersonsData = async (offSet) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL +
      `personal/persons?limit=25&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getPersonAnalytics = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + "personal/persons/analytics",
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const postPersonFileUpload = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/persons/fileUpload",
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const putPersonData = async (id, data) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `person/` + id,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const getSampleData = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/persons/sampleData",
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const finalizeImport = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/persons/finalizeImport",
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
    data: data,
  });
  return response.data;
};

export const postPersonSchema = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "personal/schema/persons",
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
    data: data,
  });
  return response.data;
};

export const getPersonById = async (id) => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + "personal/persons/" + id,
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getNotesApi = async (personId ,limit ,offSet) => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + `notes?personId=${personId}&limit=${limit}&offset=${offSet}`,
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const getNotesCountApi = async (personId) => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + `notes/count?personId=${personId}`,
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const createNoteApi = async (personId,text) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `notes`,
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
    data: { person: personId, text: text }

  });
  return response.data;
};


export const getNoteByIdApi = async (id) => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + `notes/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const putNoteByIdApi = async (id,body) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `notes/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
    data: body
  });
  return response.data;
};



export const addPerson = async (data) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + "person",
    headers: {
      Authorization: "Bearer " + getToken(),
      "Content-Type": "application/json",
    },
    data: data,
  });
  return response.data;
};